import Swiper from "swiper";

const productPageSlider = document.querySelector(".js-product-page-slider");

if (productPageSlider) {
    window.addEventListener("load", () => initProductPageSlider(productPageSlider));
}

function initProductPageSlider(slider) {
    const thumbs = document.querySelector(".js-product-page-slider-thumbs");

    if (slider && thumbs) {
        const sliderThumbs = new Swiper(thumbs, {
            spaceBetween: 6,
            slidesPerView: 6,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            observer: true,
            watchOverflow: true,
            navigation: {
                nextEl: ".js-product-page-thumb-next",
                prevEl: ".js-product-page-thumb-prev",
            },
            allowTouchMove: false,
            // фикс бага переключения слайдов при совпадении click и swipe
            on: {
                touchEnd: (s) => {
                    const diff = (s.touches.diff = s.isHorizontal()
                        ? s.touches.currentX - s.touches.startX
                        : s.touches.currentY - s.touches.startY);

                    if (diff < 3 || diff > -3) s.allowClick = true;
                },
            },
        });

        new Swiper(slider, {
            spaceBetween: 10,
            watchOverflow: true,
            pagination: {
                el: ".js-product-page-card-pagination",
                clickable: true,
            },
            thumbs: {
                swiper: sliderThumbs,
                slideThumbActiveClass: "active",
            },
        });
    }
}
